import { MultiYearsComparisonResponseDataT } from './BudgetSynthesisAndRatios/MultiYearsComparison/hooks/useGetMultiYearsComparison';

/** Get the indicators from the results for a specified year. */
export const getIndicatorsForExercice = (
    results: MultiYearsComparisonResponseDataT[],
    year: number,
): {
    cafBrut: number;
    cafNet: number;
    excedentBrut: number;
    cafBrutRatio: number;
    cafNetRatio: number;
    excedentBrutRatio: number;
} => {
    const resultsForYear = results.filter((result) => result.year === year);

    const cafBrut = resultsForYear.reduce(
        (total, item) =>
            item.year === year ? total + item.epargneBrute : total,
        0,
    );

    const cafNet = resultsForYear.reduce(
        (total, item) =>
            item.year === year ? total + item.epargneNette : total,
        0,
    );

    const excedentBrut = resultsForYear.reduce(
        (total, item) =>
            item.year === year ? total + item.epargneGestion : total,
        0,
    );

    const produitsFonctionnement = resultsForYear.reduce(
        (total, item) =>
            item.year === year ? total + item.produitsFonctionnement : total,
        0,
    );

    const cafBrutRatio = produitsFonctionnement
        ? cafBrut / produitsFonctionnement
        : 0;
    const cafNetRatio = produitsFonctionnement
        ? cafNet / produitsFonctionnement
        : 0;
    const excedentBrutRatio = produitsFonctionnement
        ? excedentBrut / produitsFonctionnement
        : 0;

    return {
        cafBrut,
        cafNet,
        excedentBrut,
        cafBrutRatio,
        cafNetRatio,
        excedentBrutRatio,
    };
};
